import { render, staticRenderFns } from "./listaZona.vue?vue&type=template&id=244b455a&scoped=true"
import script from "./listaZona.vue?vue&type=script&lang=js"
export * from "./listaZona.vue?vue&type=script&lang=js"
import style0 from "./listaZona.vue?vue&type=style&index=0&id=244b455a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244b455a",
  null
  
)

export default component.exports